<template>
  <base-filter-select
      class="user-select-box"
      v-model="model"
      :options="userOptions"
      label="fullName"
      :reduce="user => user.id"
      :multiple="multi || selectProps.multiple"
      :clearable="clearable"
      :select-props="selectProps"
      :placeholder="placeholder"
  >
    <template #option="option">
      <div class="d-flex align-content-center align-items-center">
        <b-avatar
            size="20"
            variant="light-primary"
            :src="require(`@/assets/images/avatars/${option.avatar || '1'}-small.png`)"
            class="mr-1"
        />
        <div>
          <p class="m-0 font-small-2 p-0">{{ option.fullName }}</p>
          <p class="m-0 font-small-1 text-muted p-0" v-if="showRoles">{{ roleById(option.roleId).name }}</p>
        </div>
      </div>
    </template>
  </base-filter-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BaseFilterSelect from '@/components/widget/select/BaseFilterSelect.vue'

export default {
  name: 'UserSelectBox',
  components: { BaseFilterSelect },
  props: {
    value: {
      required: true,
    },
    nullable: {
      type: Boolean,
      default: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    selectProps: {
      type: Object,
      default: () => ({})
    },
    showRoles: {
      type: Boolean,
      default: false
    },
    roles:{
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * If set, the user list is restricted to users whose `businessUnits`
     * set contains this id. Useful when picking a representative for a
     * specific branch (e.g. the duplicate-to-org wizard).
     */
    organizations:{
      type: Array,
      default: () => []
    },
    businessUnits:{
      type: Array,
      default: () => []
    },
    businessUnitId: {
      type: String,
      default: null,
    },

  },
  created() {
    if((this.showRoles || this.roles?.length > 0) && this.allRoles.length === 0) {
      this.refreshData();
    }
  },
  computed: {
    ...mapGetters('data', ['allUsers']),
    ...mapGetters('users', ['allRoles','roleById']),

    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    userOptions() {
      let users = this.allUsers || [];

      if(this.roles.length > 0) {
        users = users.filter(user => this.roles.includes(this.roleById(user.roleId).companyPosition));
      }
      if (this.businessUnitId) {
        users = users.filter(user => Array.isArray(user.businessUnits) && user.businessUnits.includes(this.businessUnitId));
      }else if (this.businessUnits != null && this.businessUnits.length > 0) {
        users = users.filter(user => Array.isArray(user.businessUnits) && user.businessUnits.some(bu => this.businessUnits.includes(bu)));
      } else if (this.organizations != null && this.organizations.length > 0) {
        users = users.filter(user => Array.isArray(user.orgIds) && user.orgIds.some(org => this.organizations.includes(org)));
      }
      if (this.selectProps.nullable) {
        return [
          { id: null, username: 'NOT ASSIGNED', fullName: 'NOT ASSIGNED' },
          ...users
        ];
      }

      return users;
    }
  },

  methods: {
    ...mapActions('users', ['refreshData']),
  },
};
</script>
